import styled from "../../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectOSXFontSmoothing } from "../../../utils/injectOSXFontSmoothing.mjs.mjs";
import { injectTypography } from "../../../utils/injectTypography.mjs.mjs";
export const StyledDateSummaryContainer = styled.div.withConfig({ displayName: "auir-611444a-StyledDateSummaryContainer", componentId: "auir-611444a-6es07g" }) `
  box-sizing: border-box;
  padding: var(${(props) => props.theme.responsive.spacing.m});

  color: var(${(props) => props.theme.colors.base.grey[0]});
  ${(props) => injectTypography(props, 'copy2')}
  ${injectOSXFontSmoothing(true)}

  background-color: var(${(props) => props.theme.colors.base.grey[100]});

  & > *:not(:last-child) {
    margin-inline-end: var(${(props) => props.theme.responsive.spacing.xs});
  }
`;
export const StyledDateSummaryDay = styled.span.withConfig({ displayName: "auir-611444a-StyledDateSummaryDay", componentId: "auir-611444a-4g25q2" }) `
  grid-area: day;

  font-size: 32px;

  line-height: 1em;
  letter-spacing: -0.03em;

  margin-inline-end: var(${(props) => props.theme.responsive.spacing.xxs});
`;
export const StyledDateSummaryMonth = styled.span.withConfig({ displayName: "auir-611444a-StyledDateSummaryMonth", componentId: "auir-611444a-cv5jly" }) `
  grid-area: month;
  margin-block-start: 1px;

  font-weight: var(${(props) => props.theme.fontWeights.bold});
  font-size: 12px;
  font-stretch: 130%;
  line-height: 1em;
`;
export const StyledDateSummaryYear = styled.span.withConfig({ displayName: "auir-611444a-StyledDateSummaryYear", componentId: "auir-611444a-xagw69" }) `
  grid-area: year;

  font-size: 10px;
  font-stretch: 130%;
  line-height: 1em;
`;
export const StyledDateSummaryLayout = styled.div.withConfig({ displayName: "auir-611444a-StyledDateSummaryLayout", componentId: "auir-611444a-efvqcv" }) `
  display: inline-grid;

  grid-template-areas:
    'day month'
    'day year';
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(2, auto);
  align-items: center;
`;
//# sourceMappingURL=DateSummary.styles.mjs.mjs.map